/**
 * Environment variable utilities for Vite
 * Provides a convenient interface to access VITE_ prefixed environment variables
 */

/**
 * Environment variable getters
 * These provide type-safe access to Vite environment variables
 */
export const env = {
  // API Configuration
  get RESIDEN_API_BASE_URL() {
    return import.meta.env.VITE_RESIDEN_API_BASE_URL || ''
  },

  // OpenAI
  get OPENAI_API_KEY() {
    return import.meta.env.VITE_OPENAI_API_KEY || ''
  },

  // Sentry
  get SENTRY_DSN() {
    return import.meta.env.VITE_SENTRY_DSN || ''
  },

  // Syncfusion
  get SYNCFUSION_KEY() {
    return import.meta.env.VITE_SYNCFUSION_KEY || ''
  },

  // Environment
  get ENV() {
    return import.meta.env.VITE_ENV || 'development'
  },

  // Google Tag Manager
  get GTM_CODE() {
    return import.meta.env.VITE_GTM_CODE || ''
  },

  get PARTNER_ID() {
    return import.meta.env.VITE_PARTNER_ID || ''
  },

  // Turnstile (captcha)
  get TURNSTILE_KEY() {
    return import.meta.env.VITE_TURNSTILE_KEY || ''
  },

  // Payment Providers
  get SQUARE_APPLICATION_ID() {
    return import.meta.env.VITE_SQUARE_APPLICATION_ID || ''
  },

  get STRIPE_KEY() {
    return import.meta.env.VITE_STRIPE_KEY || ''
  },

  // Pusher
  get PUSHER_KEY_CENTRAL() {
    return import.meta.env.VITE_PUSHER_KEY_CENTRAL || ''
  },

  get PUSHER_CLUSTER_CENTRAL() {
    return import.meta.env.VITE_PUSHER_CLUSTER_CENTRAL || ''
  },

  get PUSHER_KEY_SITE_1() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_1 || ''
  },

  get PUSHER_KEY_SITE_2() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_2 || ''
  },

  get PUSHER_KEY_SITE_3() {
    return import.meta.env.VITE_PUSHER_KEY_SITE_3 || ''
  },

  get PUSHER_CLUSTER_SITE_1() {
    return import.meta.env.VITE_PUSHER_CLUSTER_SITE_1 || ''
  },

  get PUSHER_CLUSTER_SITE_2() {
    return import.meta.env.VITE_PUSHER_CLUSTER_SITE_2 || ''
  },

  get PUSHER_CLUSTER_SITE_3() {
    return import.meta.env.VITE_PUSHER_CLUSTER_SITE_3 || ''
  },

}
